import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import Navbar from '../../components/Navbar/Navbar'
import Hero3 from '../../components/hero3/hero3';
import AppointmentSection from '../../components/AppointmentSection/AppointmentSection';
import AboutS3 from '../../components/aboutS3/aboutS3.js';
import ProcessSection from '../../components/ProcessSection/ProcessSection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import CtaSectionS2 from '../../components/CtaSectionS2/CtaSectionS2.js';
import TeamSection from '../../components/TeamSection/TeamSection';
import FunFact from '../../components/FunFact/FunFact';
import BlogSection from '../../components/BlogSection/BlogSection';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

import Logo from '../../images/Horizontal-Logo-white.png'

const HomePage3 = () => {
    const SITE_URL = 'https://pharmacyfreedomfund.com';
    const schema = [
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` }
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Home",
            "url": `${SITE_URL}/`
        }
    ];
    return (
        <Fragment>
            <SEO
                title="Home"
                description="Pharmacy Freedom Fund partners with investors and operators to acquire and grow independent pharmacies, strengthening community healthcare."
                keywords={["pharmacy investing", "independent pharmacy", "healthcare investment", "pharmacy acquisition", "Pharmacy Freedom Fund"]}
                canonical="https://pharmacyfreedomfund.com/"
                schema={schema}
            />
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <Hero3 />
            <div style={{ marginBottom: 80 }} />
            <AboutS3 />
            <ProcessSection hclass={"work_section_s2 section-padding"} />
            <ServiceSection hclass={"service_section_s3 section-padding"} />
            {/* <ProjectSection hclass={'project_section_s3 section-padding'} /> */}
            <Testimonial tClass={'testimonial_section testimonial_section_slider section-padding pt-0'} />
            <CtaSectionS2 />
            <BlogSection tClass={'blog_section section-padding'} />
            {/* <FunFact hclass={'funfact_section'} /> */}
            {/* <BlogSection tClass={'blog_section section-padding'} /> */}
            <CtafromSection hclass={'ctafrom_section'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage3;